import { BaseWebComponentRepository } from '../../../../../framework/BaseWebComponentRepository';
import { CredentialsManagerGridDataProviderFactory } from '../factory/CredentialsManagerGridDataProviderFactory';
import { CredentialsManagerGridBaseDataProvider } from '../dataProvider/CredentialsManagerGridBaseDataProvider';
import {
  AuthTypesData,
  CredentialsManagerCreateRequest,
  CredentialsManagerCreateResponse,
  CredentialsManagerGridSchema,
  UploadFileResponse,
} from '../types';

export class CredentialsManagerGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: CredentialsManagerGridDataProviderFactory;
  public dataProvider: CredentialsManagerGridBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new CredentialsManagerGridDataProviderFactory(),
    });
  }

  async createRecords(request: CredentialsManagerCreateRequest): Promise<CredentialsManagerCreateResponse> {
    return this.dataProvider.createRecords(request);
  }

  async removeRecords(request: CredentialsManagerGridSchema): Promise<CredentialsManagerCreateResponse> {
    return this.dataProvider.removeRecords(request);
  }

  public getAuthTypes(): AuthTypesData[] {
    return this.dataProvider.getAuthTypes();
  }

  public uploadFile(form: FormData): Promise<UploadFileResponse> {
    return this.dataProvider.uploadFile(this.dependencies.uploadPemCredentialsURL(), form);
  }
}
